<template>
  <div class="session-bg">
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="4"
        >
          <v-card class="popup-card">
            <v-card-title class="popup-title">
              Cambiar Contrasena
            </v-card-title>
            <v-card-text>
              <v-alert
                v-show="alert.show"
                :type="alert.type"
                dense
                outlined
                dismissible
                @input="alert.show = false"
              >
                {{ alert.message }}
              </v-alert>

              <div v-if="!passwordUpdated">
                <v-form
                  ref="form"
                  v-model="formValid"
                >
                  <v-text-field
                    v-model="token"
                    label="Codigo de seguridad"
                    :rules="[rules.required]"
                    prepend-icon="mdi-key"
                    clearable
                    outlined
                  />
                  <v-text-field
                    v-model="email"
                    label="Correo electronico"
                    type="email"
                    :rules="[rules.required, rules.email]"
                    prepend-icon="mdi-email"
                    clearable
                    outlined
                  />
                  <v-text-field
                    v-model="newPassword"
                    label="Contrasena nueva"
                    :type="showNewPassword ? 'text' : 'password'"
                    :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :rules="passwordRules"
                    prepend-icon="mdi-lock"
                    outlined
                    @click:append="showNewPassword = !showNewPassword"
                  />
                  <password-strength :password="newPassword || ''" />

                  <v-text-field
                    v-model="confirmPassword"
                    class="mt-4"
                    label="Confirmar contrasena nueva"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :rules="[rules.required, rules.matchPassword]"
                    prepend-icon="mdi-lock-check"
                    outlined
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  />
                  <v-btn
                    color="red"
                    class="white--text"
                    block
                    :loading="saving"
                    @click="validateForm"
                  >
                    Guardar
                  </v-btn>
                </v-form>
              </div>

              <div v-else>
                <p>
                  La contrasena se ha cambiado exitosamente. Por favor vuelva a
                  la pagina principal.
                </p>
                <v-btn
                  color="red"
                  class="white--text"
                  @click="goToLogin"
                >
                  Volver al inicio
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PasswordStrength from '@/components/PasswordStrength'
  import { passwordRules } from '@/utils/passwordRules'

  export default {
    name: 'RememberPassword',
    components: {
      'password-strength': PasswordStrength,
    },
    metaInfo: {
      title: 'Cambiar contrasena',
    },
    data () {
      return {
        email: '',
        token: '',
        newPassword: '',
        confirmPassword: '',
        formValid: false,
        showNewPassword: false,
        showConfirmPassword: false,
        passwordUpdated: false,
        saving: false,
        passwordRules,
        alert: {
          show: false,
          type: 'error',
          message: '',
        },
        rules: {
          required: v => !!v || 'Este campo es obligatorio',
          email: v => /.+@.+\..+/.test(v || '') || 'El correo electronico no es valido',
          matchPassword: v => v === this.newPassword || 'Las contrasenas no coinciden',
        },
      }
    },
    computed: {
      ...mapState('users', ['responsePassword']),
    },
    watch: {
      responsePassword (val) {
        if (val === null) return

        this.saving = false

        if (val.error) {
          this.showAlert('error', val.Mensaje)
        } else {
          this.showAlert('success', val.Mensaje)
          this.passwordUpdated = true
        }

        this.$store.dispatch('users/setResponsePassword', null)
      },
    },
    created () {
      const { token, email } = this.$route.query
      if (token) this.token = token
      if (email) this.email = email
    },
    methods: {
      showAlert (type, message) {
        this.alert.type = type
        this.alert.message = message
        this.alert.show = true
      },
      validateForm () {
        if (!this.$refs.form.validate()) {
          this.showAlert('error', 'Por favor completa todos los campos correctamente.')
          return
        }
        this.savePassword()
      },
      savePassword () {
        this.saving = true
        this.$store.dispatch('users/sendPasswordEmail', {
          email: this.email,
          password: this.newPassword,
          token: this.token,
        })
      },
      goToLogin () {
        this.$router.push({ name: 'login' })
      },
    },
  }
</script>

<style lang="scss">
.session-bg {
  background-color: white;
  height: 100vh;
  align-items: center;
  place-content: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
}

.popup-card {
  background-color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style>
